import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client';

const RESERVE_ORDER_ID = gql`
  mutation ReserveOrderId {
    reserveOrderId
  }
`;

export const useReservedOrderId = () => {
  const client = useApolloClient();

  return async () => {
    const { data } = await client.mutate({
      mutation: RESERVE_ORDER_ID,
    });

    return data.reserveOrderId;
  };
};
